/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsRecommendedProducts = {
  init: function($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsRecommendedProducts = $.extend(this, window.PXUTheme.getSectionData($section));

    // Look for an element with class 'product-recommendations'
    const $productRecommendations = $section.find('.product-recommendations');

    // Selectors
    const productID = $productRecommendations.data('product-id');
    const limit = $productRecommendations.data('limit');

    const sectionID = $productRecommendations.data('section-id');

    // If showing custom collection we do not want to build request url
    if (this.show_custom_collection) {
      this.showCustomCollection($section);
      return;
    }

    // Build request URL
    const shopURL = $productRecommendations.data('base-url');
    const requestUrl = `${shopURL}?section_id=${sectionID}&limit=${limit}&product_id=${productID}`;

    /*$.ajax({
      type: 'GET',
      url: requestUrl,
      success: function(data) {

        let $recommendedProductsElement = $(data).find('.product-recommendations').html();

        // Insert product list into the product recommendations container
        $productRecommendations.html($recommendedProductsElement);

        window.PXUTheme.jsProduct.relatedProducts();

        // Initialize shopify payment buttons
        if (Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }

        // Converting the currencies
        if (window.PXUTheme.currencyConverter) {
          window.PXUTheme.currencyConverter.convertCurrencies();
        }
      }
    });*/
    fetch(requestUrl, {
      method: 'GET',
      headers: {
        // Optional: Mimics jQuery behavior. Some backends require this to know it's an AJAX call.
        'X-Requested-With': 'XMLHttpRequest' 
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      // We expect HTML, so we use .text() instead of .json()
      return response.text();
    })
    .then(htmlText => {
      // 1. Parse the raw HTML string into a virtual DOM document
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlText, 'text/html');

      // 2. Find the specific element within that virtual DOM
      const recommendedContent = doc.querySelector('.product-recommendations');

      if (recommendedContent) {
        // 3. Insert the inner HTML into your container
        // (Assuming $productRecommendations is still a jQuery object)
        $productRecommendations.html(recommendedContent.innerHTML);

        // 4. Run the callbacks
        if (window.PXUTheme && window.PXUTheme.jsProduct) {
            window.PXUTheme.jsProduct.relatedProducts();
        }

        if (typeof Shopify !== 'undefined' && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }

        if (window.PXUTheme && window.PXUTheme.currencyConverter) {
          window.PXUTheme.currencyConverter.convertCurrencies();
        }

        // Register the freshly-injected recommended-product videos so they can play on hover
        window.PXUTheme.jsRecommendedProducts.setupRecommendedVideoPlayer($section);
      }
    })
    .catch(error => {
      console.error('Error fetching recommendations:', error);
    });
  },
  setupRecommendedVideoPlayer: function($section) {
    const videosInRecommendedProducts = $section.find('.product-recommendations [data-html5-video] video, .product-recommendations [data-youtube-video]').get();

    // Only load Plyr / run setup if videosInRecommendedProducts exists
    if (videosInRecommendedProducts.length > 0) {
      window.PXUTheme.ensurePlyr(function () {
        videosInRecommendedProductsPlayer = Plyr.setup(videosInRecommendedProducts, {
          controls: videoControls,
          fullscreen: {
            enabled: true,
            fallback: true,
            iosNative: true
          },
          storage: {
            enabled: false
          }
        });
        if (videoPlayers !== null) {
          var combinedArray = videoPlayers.concat(videosInRecommendedProductsPlayer);
          videoPlayers = combinedArray;
        } else {
          videoPlayers = videosInRecommendedProductsPlayer;
        }
        window.PXUTheme.video.setupListeners();
      });
    } else {
      window.PXUTheme.video.setupListeners();
    }
  },
  showCustomCollection: function($section) {
    const $recommendedProductsElement = $section.find('.product-recommendations').html();

    const $productRecommendationsContainer = $('.product-recommendations');
    $productRecommendationsContainer.html($recommendedProductsElement);

    window.PXUTheme.jsProduct.relatedProducts();
    window.PXUTheme.jsRecommendedProducts.setupRecommendedVideoPlayer($section);
  },
  unload: function($section) {
  }
}

/******/ })()
;